import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const CategoryVoiceOverLargeIcon = ({
    size = 24,
    color = 'currentFill'
}: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 32 32"
        fill={color}
        xmlns="http://www.w3.org/2000/svg">
        <path d="M9.538 9.759c0-3.62 2.893-6.553 6.462-6.553s6.462 2.933 6.462 6.553v3.745a.93.93 0 0 0 .923.936.93.93 0 0 0 .923-.936V9.759c0-4.654-3.72-8.426-8.308-8.426-4.589 0-8.308 3.772-8.308 8.426v3.745a.93.93 0 0 0 .923.936.93.93 0 0 0 .923-.936V9.759Z"
            fill="#404145"/>
        <path fillRule="evenodd"
            clipRule="evenodd"
            d="M4.923 17.56a.93.93 0 0 0-.923.936.93.93 0 0 0 .923.937h2.77v.312c0 4.337 3.23 7.908 7.384 8.374v1.611a.93.93 0 0 0 .923.937.93.93 0 0 0 .923-.937V28.12c4.154-.466 7.385-4.037 7.385-8.374v-.312h2.769a.93.93 0 0 0 .923-.937.93.93 0 0 0-.923-.936H4.923Zm17.539 2.185c0 3.62-2.893 6.553-6.462 6.553s-6.462-2.934-6.462-6.553v-.312h12.924v.312Z"
            fill="#404145"/>
    </svg>
);
CategoryVoiceOverLargeIcon.displayName = 'CategoryVoiceOverLargeIcon';
export default CategoryVoiceOverLargeIcon;
